import React from 'react';
import PropTypes from 'prop-types';
import { List } from 'antd';
import TwoColumnsFlexLayout from '../../../shared/components/layout/TwoColumnsFlex.layout';
import { Box, ShowIf, Text } from '../../../shared/components';


function dangerouslyClickHandler(element) {
  const { target } = element;
  if (target) {
    const { classList } = target;
    if (classList.contains('giolink')) {
      window.parent.postMessage(target.dataset.giodata, '*');
    }
  }
}

const NotificacionListItem = ({ mensaje }) => {
  const {
    titulo, contenido, leido, prettyDate: fechaCreacion, suscripcion,
  } = mensaje;

  const { description: descripcionSuscripcion } = suscripcion;
  return (
    <List.Item style={{ borderBottomColor: '#1d586f' }}>
      <List.Item.Meta
        title={(
          <TwoColumnsFlexLayout
            flexLeft={4}
            rightColumnStyle={{ maxWidth: '80px' }}
            leftContent={(
              <Box>
                <Box><Text fontSize="16" color="white">{titulo}</Text></Box>
                <Text fontSize="12" color="#CDD8EB">{descripcionSuscripcion}</Text>
              </Box>
            )}
            rightContent={(
              <Box style={{ width: '100%', textAlign: 'center' }}>
                <Box>
                  <Text fontSize="12" color="white">{fechaCreacion}</Text>
                </Box>
                <ShowIf condition={leido === false}>
                  <Box>
                    <Text fontSize="12" color="#FFB35D">Nuevo</Text>
                  </Box>
                </ShowIf>
              </Box>
            )}
          />
        )}
        description={(
          <Box pt="12">
            <div
              className={'notificacion-list-item'}
              onClick={element => dangerouslyClickHandler(element)}
              style={{ color: 'white', fontSize: '14px' }}
              dangerouslySetInnerHTML={{ __html: contenido }}
            />
          </Box>
        )}
      />
    </List.Item>
  );
};

NotificacionListItem.propTypes = {
  mensaje: PropTypes.shape({
    contenido: PropTypes.string.isRequired,
    fechaCreacion: PropTypes.any.isRequired,
    leido: PropTypes.bool.isRequired,
    titulo: PropTypes.string.isRequired,
  }).isRequired,
}

export default NotificacionListItem;
